import {
    Component,
    ElementRef,
    Input
} from '@angular/core';

@Component({
    selector: 'pm-layout-5',
    templateUrl: './layout-5.html'  
})
export class Layout5Component {
   
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-5-component.ts